const doc = [({"da":({"js":({"upload_button":({"index":({"choose_files":"Vælg filer"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;